import { Delete } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import RichTextEditor from "react-rte";

const NoteDetail = ({ data, updateName, saveHandler, deleteToggle }) => {
  const [value, setValue] = useState(
    RichTextEditor.createValueFromString(data.notes, "html")
  );

  const onChange = (value) => {
    const title = value
      .toString("html")
      .replace(/<[^>]+>/g, "") // Remove HTML tags
      .replace(/&nbsp;/g, " ") // Replace non-breaking spaces with normal spaces
      .trim();
    updateName(data.id, title.split("\n")[0]);
    setValue(value);
  };

  const toolbarConfig = {
    display: [
      "INLINE_STYLE_BUTTONS",
      "BLOCK_TYPE_BUTTONS",
      "BLOCK_TYPE_DROPDOWN",
      "HISTORY_BUTTONS",
      "ALIGNMENT_BUTTONS",
    ],
    INLINE_STYLE_BUTTONS: [
      { label: "Bold", style: "BOLD", className: "custom-bold-button" },
      { label: "Italic", style: "ITALIC", className: "custom-italic-button" },
      {
        label: "Underline",
        style: "UNDERLINE",
        className: "custom-underline-button",
      },
      {
        label: "Strikethrough",
        style: "STRIKETHROUGH",
        className: "custom-strikethrough-button",
      },
      { label: "Monospace", style: "CODE", className: "custom-code-button" },
    ],
    BLOCK_TYPE_BUTTONS: [
      {
        label: "UL",
        style: "unordered-list-item",
        className: "custom-ul-button",
      },
      {
        label: "OL",
        style: "ordered-list-item",
        className: "custom-ol-button",
      },
      {
        label: "Blockquote",
        style: "blockquote",
        className: "custom-blockquote-button",
      },
    ],
    BLOCK_TYPE_DROPDOWN: [
      { label: "Normal", style: "unstyled" },
      { label: "Heading 1", style: "header-one" },
      { label: "Heading 2", style: "header-two" },
      { label: "Heading 3", style: "header-three" },
      { label: "Heading 4", style: "header-four" },
      { label: "Heading 5", style: "header-five" },
      { label: "Heading 6", style: "header-six" },
    ],
    HISTORY_BUTTONS: [
      { label: "Undo", style: "UNDO", className: "custom-undo-button" },
      { label: "Redo", style: "REDO", className: "custom-redo-button" },
    ],
    ALIGNMENT_BUTTONS: [
      {
        label: "Align Left",
        style: "ALIGN_LEFT",
        className: "custom-align-left-button",
      },
      {
        label: "Align Center",
        style: "ALIGN_CENTER",
        className: "custom-align-center-button",
      },
      {
        label: "Align Right",
        style: "ALIGN_RIGHT",
        className: "custom-align-right-button",
      },
      {
        label: "Align Justify",
        style: "ALIGN_JUSTIFY",
        className: "custom-align-justify-button",
      },
    ],
  };

  const onSave = () => {
    saveHandler(value);
  };

  useEffect(() => {
    if (data.notes.length > 0) {
      setValue(RichTextEditor.createValueFromString(data.notes, "html"));
    } else if (value.getEditorState().getCurrentContent().hasText()) {
      setValue(RichTextEditor.createEmptyValue());
    }
  }, [data?.notes, data?.id]);

  return (
    <div className="notes-detail">
      <button className="delete-note" onClick={deleteToggle}>
        <Delete />
      </button>
      <RichTextEditor
        autoFocus={data.isNew}
        toolbarConfig={toolbarConfig}
        onBlur={onSave}
        className="note-editor"
        editorClassName="editor"
        toolbarClassName="toolbar"
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default NoteDetail;
